module.exports = __webpack_public_path__ + "img/slider-home-1.0f6be963.png";